import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const PURIFY_CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'h3', 'h4', 'hr'],
  ALLOWED_ATTR: [],
};

/**
 * Detects if content is HTML (from TipTap) or plain text (legacy).
 * Plain text is converted to paragraphs for consistent rendering.
 */
const normalizeContent = (content) => {
  if (!content) return '';
  // If it already contains HTML tags, treat it as HTML
  if (/<[a-z][\s\S]*>/i.test(content)) {
    return content;
  }
  // Plain text: convert line breaks to <p> tags
  return content
    .split(/\n\n+/)
    .map((block) => {
      const inner = block.replace(/\n/g, '<br>');
      return `<p>${inner}</p>`;
    })
    .join('');
};

const RichTextRenderer = ({ content, className = '' }) => {
  const html = useMemo(() => {
    const normalized = normalizeContent(content);
    return DOMPurify.sanitize(normalized, PURIFY_CONFIG);
  }, [content]);

  if (!content) return null;

  return (
    <div
      className={`prose prose-slate prose-sm max-w-none break-words
        [&_p]:mb-2 [&_p]:leading-relaxed
        [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-2
        [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-2
        [&_li]:mb-0.5
        [&_strong]:font-semibold
        [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-3 [&_h3]:mb-1
        [&_h4]:text-sm [&_h4]:font-semibold [&_h4]:mt-2 [&_h4]:mb-1
        [&_hr]:my-3 [&_hr]:border-slate-200
        ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
      data-testid="rich-text-content"
    />
  );
};

export default RichTextRenderer;
